<script>
	let interval = null;
	let wakeLock = null;

	const toMinutes = (n) => {
		let minutes = (Math.floor(n / 60) + '').padStart(2, '0');
		let seconds = (Math.floor(n % 60) + '').padStart(2, '0');
		return minutes + ':' + seconds;
	}

	const updateClocks = () => {
		players[turn].time -= (performance.now() - clockStart)/1000
		clockStart = performance.now();

		if(players[turn].time <= 0){
			pauseClock();
			players[turn].time = 0;
			players[turn].lose = true;
		}

		players = players;
	}

	const startClock = async (player) => {
		clockStart = performance.now();
		if( ! interval){
			interval = setInterval(() => {
				updateClocks()
			}, 250);
		}
		if ('wakeLock' in navigator) {
		  wakeLock = await navigator.wakeLock.request();
		}
	}

	const pauseClock = () => {
		console.log("pausing clock...");
		if(interval){
			clearInterval(interval);
			interval = null;
		}
		if(wakeLock){
			wakeLock.release();
		  wakeLock = null;
		}
	}

	const goSettings = () => {
		view = 'settings'
	}

	const setDefault = (t, i) => {
		defaults.p1time = t * 60;
		defaults.p1increment = i;
		defaults.p2time = t * 60;
		defaults.p2increment = i;
		defaults = defaults;
		goClock();
	}


	const goClock = () => {
		players.p1.time = defaults.p1time;
		players.p1.increment = defaults.p1increment;
		players.p2.time = defaults.p2time;
		players.p2.increment = defaults.p2increment;
		view = 'clock'
	}

	const handleClick = (player) => {
		console.log(player);
		// console.log(p1class);

		if(player == waiting){
			return;
		}

		if(!turn){
				turn = player == 'p1' ? 'p2' : 'p1';
				waiting = player == 'p1' ? 'p1' : 'p2';
				players[turn].active = true;
				players[waiting].active = false;
				console.log(turn, waiting, players);
				// start clock
				players = players;
				startClock(turn);
				return 
		}

		players[turn].time += players[turn].increment;

		turn = turn == 'p1' ? 'p2' : 'p1';
		waiting = turn == 'p1' ? 'p2' : 'p1';
		players[turn].active = true;
		players[waiting].active = false;
		players = players;
	}

	let status = 'before';
	let turn = null;
	let waiting = null;
	let clockStart = null;
	let view = 'clock';

	let defaults = {
		p1time: 3 * 60,
		p2time: 3 * 60,
		p1increment: 2,
		p2increment: 2,
	}

	let players = {
		p1: {
			time: 3 * 60,
			increment: 2,
			active: turn == 'p1',
			lose: false,
		},
		p2: {
			time: 3 * 60,
			increment: 2,
			active: turn == 'p2',
			lose: false,
		}
	}


	$: p1class = "player p1 " + (turn == 'p1' ? 'active' : '');
	$: p2class = "player p2 " + (turn == 'p2' ? 'active' : '');
</script>

{#if view == 'clock'}
<div class="clock">
  <div class="player" class:active="{players.p1.active}" class:lose="{players.p1.lose}" on:click={() => handleClick('p1')}>
    <div class="player--time">{toMinutes(players.p1.time)}</div>
  </div>
  <div class="settings">
    <span on:click={goSettings} class="material-icons">settings</span>
    {#if turn && interval}
    <span on:click={pauseClock} class="material-icons">pause</span>
    {:else if turn && !interval}
		<span on:click={startClock} class="material-icons">play_arrow</span>
    {/if}
  </div>
  <div class="player" class:active="{players.p2.active}" class:lose="{players.p2.lose}" on:click={() => handleClick('p2')}>
    <div class="player--time">{toMinutes(players.p2.time)}</div>
  </div>
</div>
{:else}
	<div class="settings-page">
		<h1>Settings</h1>
		<h2>Standard</h2>
		<div class="standard-times">
			<button type="button" on:click={() => setDefault(1,0)}>1+0</button>
			<button type="button" on:click={() => setDefault(2,1)}>2+1</button>
			<button type="button" on:click={() => setDefault(3,0)}>3+0</button>
			<button type="button" on:click={() => setDefault(3,2)}>3+2</button>
			<button type="button" on:click={() => setDefault(5,0)}>5+0</button>
			<button type="button" on:click={() => setDefault(5,3)}>5+3</button>
			<button type="button" on:click={() => setDefault(10,0)}>10+0</button>
			<button type="button" on:click={() => setDefault(10,5)}>10+5</button>
			<button type="button" on:click={() => setDefault(15,10)}>15+10</button>
			<button type="button" on:click={() => setDefault(30,0)}>30+0</button>
			<button type="button" on:click={() => setDefault(30,20)}>30+20</button>
		</div>

		<h2>Custom...</h2>
		<h3>Player 1</h3>
		<div>
			<label for="p1time">Time</label>
			<input type="number" bind:value={defaults.p1time} id="p1time" />
		</div>
		<div>
			<label for="p1increment">Time</label>
			<input type="number" bind:value={defaults.p1increment} id="p1increment" />
		</div>
		<h3>Player 2</h3>
		<div>
			<label for="p2time">Time</label>
			<input type="number" bind:value={defaults.p2time} id="p2time" />
		</div>
		<div>
			<label for="p2increment">Time</label>
			<input type="number" bind:value={defaults.p2increment} id="p2increment" />
		</div>
		<div>
			<button on:click={goClock} type="button" value="Done">Done</button>
		</div>
	</div>
{/if}

<style>
.clock{
  overflow: hidden;
  display: grid;
  grid-template-rows: 1fr 44px 1fr;
}

.standard-times{
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	grid-template-rows: 1fr 1fr 1fr;
	grid-gap: 10px;
}

.player{
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.player.active{
	background: blue;
	color: #fff;
}
.player.lose{
	background: red;
	animation: loseBlink 1s steps(1) infinite;
}

@keyframes loseBlink {
	0% { background: red; color: #fff; }
	50% { background: #fff; color: red; }
	100% { background: #fff; color: red; }
}

.player:first-child{
  transform: rotate(180deg);
}

@media(orientation: portrait){
	.player--time{
    font-size: 30vw;
  }
}
@media(orientation: landscape){
	.player--time{
    font-size: 30vh;
  }
}

label, input{
	display: block;
}
input{
	width: 100%;
	padding: 4px;
}

.settings-page{
  width: 400px;
  margin: 0 auto;
  max-width: 100%;
  padding: 0 10px;
  height: 100%;
	overflow-y: auto;
	padding-bottom: 2em;
}
.settings-page div + div{
	margin-top: 15px;
}

.standard-times > div{
	padding: 20px 0;
	text-align: center;
	margin-top: 0;
	border: 1px solid #555;
}
.standard-times > div + div{
	margin-top: 0;
}
.settings{
	display: flex;
	align-items: center;
	justify-content: center;
}

.settings .material-icons{
	padding: 10px;
	cursor: pointer;
}

button{
	background: black;
  width: 100%;
  appearance: none;
  display: block;
  color: white;
  padding: 10px;
  border: none;
  cursor: pointer;
}
</style>